// extracted by mini-css-extract-plugin
export default {"container":"style_container__MmVYQ","modalHeader":"style_modalHeader__5oJRZ","cardWrapper":"style_cardWrapper__rFUrl","certificateCard":"style_certificateCard__rUhoq"};